<template>
  <div class="account-profile-tab">
    <el-tabs v-model="activeSubTab" @tab-click="handleSubTabClick">
      <el-tab-pane label="Customer Requirements/Pain Points" name="customerReq">
        <account-profile-customer-req ref="customerReq" :account-info="accountInfo" :has-operation-permission="hasOperationPermission"></account-profile-customer-req>
      </el-tab-pane>
      <el-tab-pane label="Competitor Info" name="competitorInfo">
        <account-profile-competitor-info ref="competitorInfo" :account-info="accountInfo" :has-operation-permission="hasOperationPermission"></account-profile-competitor-info>
      </el-tab-pane>
      <el-tab-pane label="Customer Network Maintenance Mode" name="networkMaint">
        <account-profile-network-maint ref="networkMaint" :account-info="accountInfo" :has-operation-permission="hasOperationPermission"></account-profile-network-maint>
      </el-tab-pane>
      <el-tab-pane label="Uninspected Device Info" name="uninspectedDev">
        <account-profile-uninspected-dev ref="uninspectedDev" :account-info="accountInfo" :has-operation-permission="hasOperationPermission"></account-profile-uninspected-dev>
      </el-tab-pane>
    </el-tabs>
    <div ref="apActions" class="ap-actions" v-if="hasOperationPermission">
      <el-upload
        class="ap-upload-btn"
        action="#"
        :http-request="handleUpload"
        :show-file-list="false"
        accept=".xlsx,.xls"
      >
        <el-button type="primary" size="mini" :loading="uploadLoading">Upload</el-button>
      </el-upload>
      <el-button size="mini" type="primary" plain @click="handleDownloadTemplate">Download Template</el-button>
    </div>
    <el-dialog title="Import Result" :visible.sync="errorDialogVisible" width="560px" append-to-body>
      <div v-if="importResult">
        <p style="margin-top:-15px;margin-bottom:14px;line-height:1.8;color:#333">
          Customer Requirements/Pain Points: <b>{{ importResult.painPointCount }}</b>,
          Competitor Info: <b>{{ importResult.competitorCount }}</b><br />
          Customer Network Maintenance Mode: <b>{{ importResult.networkMaintenanceCount }}</b>,
          Uninspected Device Info: <b>{{ importResult.uninspectedDeviceCount }}</b><br />
          Success: <b style="color:#67C23A;padding-right:4px">{{ importResult.successCount }}</b>,
          Failed: <b style="color:#F56C6C">{{ importResult.failCount }}</b>
        </p>
        <div v-if="importResult.errorList && importResult.errorList.length"
          style="background:#FDF6EC;border:1px solid #FAECD8;border-radius:4px;padding:14px 18px">
          <div style="font-weight:600;color:#E6A23C;margin-bottom:10px;font-size:14px">
            <i class="el-icon-warning" style="margin-right:6px"></i>Error Details
          </div>
          <div v-for="(e, i) in importResult.errorList" :key="i"
            :style="{lineHeight:'2',color:'#333',fontSize:'13px',paddingLeft:'4px'}">
            <span style="margin-right:4px">[{{ e.sheet }}]</span>
            <span style="font-weight:600;margin-right:4px">Row {{ e.row }}:</span>
            <span style="color:#E6A23C">{{ e.message }}</span>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="errorDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AccountProfileCustomerReq from './AccountProfileCustomerReq.vue'
import AccountProfileCompetitorInfo from './AccountProfileCompetitorInfo.vue'
import AccountProfileNetworkMaint from './AccountProfileNetworkMaint.vue'
import AccountProfileUninspectedDev from './AccountProfileUninspectedDev.vue'

export default {
  name: 'AccountProfileTab',
  components: {
    AccountProfileCustomerReq,
    AccountProfileCompetitorInfo,
    AccountProfileNetworkMaint,
    AccountProfileUninspectedDev,
  },
  props: {
    accountInfo: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      activeSubTab: 'customerReq',
      uploadLoading: false,
      errorDialogVisible: false,
      importResult: null,
      // Permission
      hasOperationPermission: false,
    }
  },
  created() {
    this.checkOperationPermission()
  },
  mounted() {
    const header = this.$el.querySelector('.el-tabs__header')
    const actions = this.$refs.apActions
    if (header && actions) {
      header.appendChild(actions)
    }
  },
  methods: {
    handleSubTabClick(tab) {
      this.$nextTick(() => {
        const refMap = {
          customerReq: 'customerReq',
          competitorInfo: 'competitorInfo',
          networkMaint: 'networkMaint',
          uninspectedDev: 'uninspectedDev',
        }
        const ref = refMap[tab.name]
        if (ref && this.$refs[ref] && typeof this.$refs[ref].loadData === 'function') {
          this.$refs[ref].loadData()
        }
        // Fix: 子tab切换后强制el-table重新布局，防止fixed-right列高度计算错误
        this.$nextTick(() => {
          const tables = this.$el.querySelectorAll('.el-table')
          tables.forEach(table => {
            const tableComponent = table.__vue__
            if (tableComponent && typeof tableComponent.doLayout === 'function') {
              tableComponent.doLayout()
            }
          })
        })
      })
    },
    handleUpload({ file }) {
      const id = this.accountInfo.id
      if (!id) {
        this.$message.warning('Account info not loaded yet')
        return
      }
      this.uploadLoading = true
      const fd = new FormData()
      fd.append('file', file)
      const url = `${this.$store.state.islhurl}valued-account/profile/${id}/import`
      this.$axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        this.uploadLoading = false
        const data = res.data
        if (data.code === 200) {
          const r = data.data
          const summary = `Import completed: Customer Requirements/Pain Points ${r.painPointCount}, Competitor Info ${r.competitorCount}, Customer Network Maintenance Mode${r.networkMaintenanceCount}, Uninspected Device Info ${r.uninspectedDeviceCount}, Success ${r.successCount}, Failed ${r.failCount}`
          if (r.failCount > 0 && r.errorList && r.errorList.length) {
            this.importResult = r
            this.errorDialogVisible = true
          } else {
            this.$message.success(summary)
          }
          // Refresh current tab data
          const ref = this.activeSubTab
          const refMap = { customerReq: 'customerReq', competitorInfo: 'competitorInfo', networkMaint: 'networkMaint', uninspectedDev: 'uninspectedDev' }
          if (refMap[ref] && this.$refs[refMap[ref]] && typeof this.$refs[refMap[ref]].loadData === 'function') {
            this.$refs[refMap[ref]].loadData()
          }
        } else {
          this.$message.error(data.msg || 'Import failed!')
        }
      }).catch(() => {
        this.uploadLoading = false
        this.$message.error('Import failed!')
      })
    },
    checkOperationPermission() {
      let buttonpermsStr = localStorage.getItem("userRolePerm") || sessionStorage.getItem("userRolePerm")
      let buttonperms = JSON.parse(buttonpermsStr)
      if (buttonperms && Array.isArray(buttonperms)) {
        this.hasOperationPermission = buttonperms.some(p => p.indexOf('accountProfileEdit') > -1)
      }
    },
    handleDownloadTemplate() {
      const url = `${this.$store.state.islhurl}valued-account/profile/import/template`
      this.$axios({
        url,
        method: 'get',
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'AccountProfile_Template_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.$message.error('Download template failed!')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.account-profile-tab {
  /deep/.el-tabs__header {
    display: flex;
    align-items: center;
  }
  /deep/.el-tabs__nav-wrap {
    flex: 1;
  }
  /deep/.el-tabs__content {
    padding: 10px 15px;
  }
  /deep/.el-tabs__item {
    color: #6b7280;
    font-weight: normal;
  }
  /deep/.el-tabs__item.is-active {
    color: #409EFF;
  }

  .ap-actions {
    flex-shrink: 0;
    border-bottom: 2px solid #E4E7ED;
    padding-bottom: 5px;
    padding-top: 6px;
    display: flex;
    align-items: center;
    gap: 4px;

    .ap-upload-btn {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/AccountProfile.vue